import mapboxgl from 'mapbox-gl';

const fitMapToMarkers = (map, markers) => {
  const bounds = new mapboxgl.LngLatBounds();
  markers.forEach(marker => bounds.extend([marker.lng, marker.lat]));
  map.fitBounds(bounds, { padding: 70, maxZoom: 6, duration: 0 });
};

const buildCircleMap = (containerId) => {
  const mapElement = document.getElementById(containerId);
  if (!mapElement) return;

  mapboxgl.accessToken = mapElement.dataset.mapboxApiKey;

  const map = new mapboxgl.Map({
    container: containerId,
    style: 'mapbox://styles/mapbox/streets-v11'
  });

  const markers = JSON.parse(mapElement.dataset.markers);

  markers.forEach((marker) => {
    const size = 20 + Math.log2(marker.count || 1) * 10;

    const el = document.createElement('div');
    el.className = 'circle-marker';
    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.backgroundColor = 'rgba(0, 123, 255, 0.4)';
    el.style.borderRadius = '50%';
    el.style.border = '1px solid #007bff';
    el.style.display = 'flex';
    el.style.justifyContent = 'center';
    el.style.alignItems = 'center';
    el.style.color = '#000';
    el.style.fontSize = '12px';
    el.innerHTML = marker.count;

    const popup = new mapboxgl.Popup().setHTML(marker.infoWindow);

    new mapboxgl.Marker(el)
      .setLngLat([marker.lng, marker.lat])
      .setPopup(popup)
      .addTo(map);
  });

  fitMapToMarkers(map, markers);
};

const initMapboxGeolocations = () => {
  buildCircleMap('map-geolocations-1');
  buildCircleMap('map-geolocations-2');
};

export { initMapboxGeolocations };
